import React, { useState, useEffect } from "react";

import styles from "./MainApp.atoms.Filters.SearchSimple.module.scss";
const SearchSimple = ({ placeholder, handleSubmit, valueSearch }) => {
  const [value, setValue] = useState(valueSearch);

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const clearInput = () => {
    setValue("");
    handleSubmit("");
  };

  const _handleSubmit = (e) => {
    e.preventDefault();
    handleSubmit(value);
  };

  return (
    <div className={styles["simple-search-wrapper"]}>
      <form onSubmit={_handleSubmit}>
        <i className={`icon-iconos_buscar ${styles["search-icon-desktop"]}`}></i>
        <input
          className={styles["search-input"]}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          data-automation-id="search-input"
        ></input>
        {value && value.length > 0 && (
          <div
            className={styles["search-close-wrapper"]}
            onClick={clearInput}
            data-automation-id="search-cancel"
          >
            <i className={`icon-iconos_close2 ${styles["search-icon-close"]}`}></i>
          </div>
        )}
      </form>
    </div>
  );
};

export default SearchSimple;
